import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { tv, type VariantProps } from 'tailwind-variants';

const callout = tv({
  base: 'w-full rounded-lg border p-4 text-sm',
  variants: {
    variant: {
      info: 'border-blue-200 bg-blue-50 text-blue-900',
      warning: 'border-yellow-200 bg-yellow-50 text-yellow-900',
      danger: 'border-red-500/50 bg-red-50 text-red-600',
      success: 'border-green-200 bg-green-50 text-green-900',
    },
  },
  defaultVariants: {
    variant: 'info',
  },
});

type CalloutProps = VariantProps<typeof callout> & {
  children: React.ReactNode;
  className?: string;
};

export const Callout = ({
  children,
  variant = 'info',
  className,
}: CalloutProps) => {
  return (
    <div
      role="status"
      aria-live="polite"
      className={callout({ variant, className })}
    >
      <div className="flex">
        <InformationCircleIcon className="mr-2 mt-0.5 size-4 shrink-0" />
        <div>{children}</div>
      </div>
    </div>
  );
};
